import { LocalNotificationsPlugin } from '@capacitor/local-notifications';

import { AlarmWithUserAlarm } from 'src/models/alarm';

import { Callback } from 'src/util/query/models/Callback';

import { AlarmTranslator } from '../types';
import {
	AlarmAcquisitionResult,
	FOREGROUND_ALARM_ACQUISITION,
	createFailedAlarmAcquisition,
	createSuccessfulAlarmAcquisition,
	reconcileAlarmNotifications,
} from './AlarmNotificationReconciler';

export class ForegroundAlarmCallback extends Callback<Array<AlarmWithUserAlarm>> {
	public constructor(
		private readonly localNotifications: LocalNotificationsPlugin | null,
		private readonly setAlarms: (alarms: AlarmWithUserAlarm[]) => void,
		private readonly t: AlarmTranslator
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): AlarmAcquisitionResult => {
		this.logFailureResponse(failureResponse);
		return createFailedAlarmAcquisition(FOREGROUND_ALARM_ACQUISITION);
	};

	successCallbackFunction = (successResponse: Array<AlarmWithUserAlarm>): void => {
		const snapshot = createSuccessfulAlarmAcquisition(successResponse, FOREGROUND_ALARM_ACQUISITION);
		if (this.localNotifications === null || this.localNotifications === undefined) {
			this.setAlarms(snapshot.desiredRows);
			return;
		}

		void reconcileAlarmNotifications(snapshot, this.localNotifications, this.t)
			.then(() => this.setAlarms(snapshot.desiredRows))
			.catch(() => undefined);
	};
}
